import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import { CaseReportSignature, User } from "pwapi";

import { wipeCaseDetail } from "shared/actions/caseDetailActions";
import { fetchCaseReport } from "shared/actions/caseReportActions";

import CaseReport from "components/caseReport/CaseReport";
import { getDiagnosesObject } from "components/caseReport/utils";
import Spinner from "components/Spinner";
import ApplicationState from "store/ApplicationState";

const FinalReportPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const case_id = parseInt(useParams<{ case_id: string }>().case_id || "0");
  const report_id = parseInt(
    useParams<{ report_id: string }>().report_id || "0"
  );

  const serializedCase = useSelector(
    (state: ApplicationState) => state.caseDetail
  );
  const report = useSelector(
    ({ caseReport }: ApplicationState) => caseReport?.[report_id]
  );
  const currentUser: User | undefined = useSelector(
    ({ auth }: ApplicationState) => auth.user
  );

  useEffect(() => {
    case_id &&
      report_id &&
      dispatch(
        fetchCaseReport({
          case_id: case_id,
          report_id: report_id,
        })
      );
  }, [location]);

  useEffect(() => {
    return () => {
      wipeCaseDetail();
    };
  });

  return !serializedCase || !report ? (
    <Spinner />
  ) : (
    <CaseReport
      caseDetailObject={serializedCase}
      diagnoses={getDiagnosesObject(
        serializedCase.specimenDetail,
        "final",
        currentUser
      )}
      currentUser={currentUser}
      isPreview={false}
      selectedSignature={report.signature as CaseReportSignature} // TODO: double check types here
      locationCode={report?.location_code}
    />
  );
};

export default FinalReportPage;
